/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 17.03.14
 *   Time: 12:26
 */

import { TimeType } from "./TimeType";

export class Time {
    constructor(value: number, type: TimeType = null, roundTo: TimeType = null) {
        type = type || TimeType.MILLISECONDS;
        roundTo = roundTo || TimeType.BIGGEST;
        this.update(value, type, roundTo);
    }

    private _mls: number;

    private _major: TimeType;

    public get major(): TimeType {
        return this._major;
    }

    private _milliseconds: number;

    public get milliseconds(): number {
        return this._milliseconds;
    }

    public set milliseconds(value: number) {
        this.update(value, TimeType.MILLISECONDS);
    }

    private _seconds: number;

    public get seconds(): number {
        return this._seconds;
    }

    public set seconds(value: number) {
        this.update(value, TimeType.SECONDS);
    }

    private _minutes: number;

    public get minutes(): number {
        return this._minutes;
    }

    public set minutes(value: number) {
        this.update(value, TimeType.MINUTES);
    }

    private _hours: number;

    public get hours(): number {
        return this._hours;
    }

    public set hours(value: number) {
        this.update(value, TimeType.HOURS);
    }

    private _days: number;

    public get days(): number {
        return this._days;
    }

    public set days(value: number) {
        this.update(value, TimeType.DAYS);
    }

    private _weeks: number;

    public get weeks(): number {
        return this._weeks;
    }

    private _months: number;

    public get months(): number {
        return this._months;
    }

    private _years: number;

    public get years(): number {
        return this._years;
    }

    private _millenniums: number;

    public get millenniums(): number {
        return this._millenniums;
    }

    public set weeks(value: number) {
        this.update(value, TimeType.WEEKS);
    }

    public roundTo(type: TimeType): void {
        this.update(this._mls, TimeType.MILLISECONDS, type);
    }

    private update(value: number, type: TimeType, roundTo: TimeType = null): void {
        this._milliseconds = this._seconds = this._minutes = this._hours = this._days = this._weeks = 0;
        value = value < 0 ? 0 : value;
        roundTo = roundTo || TimeType.BIGGEST;
        this._major = type;
        this._mls = this._milliseconds = value * type.milliseconds;

        // Here we are looking for the biggest(major) time quant
        let timeType: TimeType;
        let left: number = TimeType.values.length - 1; // the biggest possible time measurement
        let right: number = TimeType.values.indexOf(type); // the current one
        let i: number;
        for (i = left; i > right; i--) {
            timeType = TimeType.values[i];

            // Here we check whether milliseconds are sufficient for timeType and
            // whether fit roundType condition
            if (this._mls / timeType.milliseconds >= 1 && timeType.milliseconds <= roundTo.milliseconds) {
                this._major = timeType;
                break;
            }
        }

        if (this._major == TimeType.MILLISECONDS) {
            return;
        }

        let length: number = TimeType.values.length;
        let vector: number[] = [this._milliseconds];
        let saved: number;
        let previous: number;

        // breaking seconds into time quants
        for (i = 1; i < length; i++) {
            timeType = TimeType.values[i];
            previous = vector[i - 1];
            saved = previous;
            previous %= timeType.rate;
            vector[i] = (saved - previous) / timeType.rate;
            vector[i - 1] = previous;

            if (timeType == this._major) {
                break;
            }
        }

        vector.reverse();
        this._milliseconds = Number(vector.pop());
        this._seconds = vector.pop() || 0;
        this._minutes = vector.pop() || 0;
        this._hours = vector.pop() || 0;
        this._days = vector.pop() || 0;
        this._weeks = vector.pop() || 0;
        this._months = vector.pop() || 0;
        this._years = vector.pop() || 0;
        this._millenniums = vector.pop() || 0;
    }

    public toVector(): number[] {
        return [this._milliseconds, this._seconds, this._minutes, this._hours, this._days, this._weeks, this._months, this._years, this._millenniums];
    }
}
